import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { ProjectCover } from "@/components/organisms/ProjectCover";
import { ProjectNav } from "@/components/organisms/ProjectNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";
import projectIllust3 from "/public/project-illust3.webp";

export default function ProjectArticle3(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "1つの要件で考えない。お客さまと共に見つけ出す、課題の解決法。"
        }
        pageDescription={
          "株式会社トッカシステムズのプロジェクト事例。1つの要件で考えない。お客さまと共に見つけ出す、課題の解決法。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/project/3"}
        imgUrl={"/public/project-illust3.webp"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Project",
                  path: "/project/",
                },
                {
                  name: "1つの要件で考えない。お客さまと共に見つけ出す、課題の解決法。",
                },
              ]}
            />
            <Inner className="pt-0 pb-10 md:pt-6 md:pb-20">
              {/* cover */}
              <ProjectCover
                id="3"
                href="/career/voice/3"
                title="1つの要件で考えない。<br>お客さまと共に見つけ出す、<br class='sp'/>課題の解決法。"
                intro="日本企業の海外派遣社員を対象とした新人研修教育のサポートツールの制作。<br class='pc'/>トッカシステムズでは、要件のヒアリングからシステムの提案、システムの実装まで、約一年がかりの開発工程を一貫した体制で、お客様の課題に向き合いました。"
                src="/project-keyVisual3.svg"
                bgClassName="bg-project-no3"
                imageClassName="2xs:right-[14px] 2xs:top-[14px] xs:right-[15px] xs:top-[20px] aspect-1/1 2xs:w-[76px] xs:w-[88px] sm:w-[168px] md:top-1/4 md:right-[40px] md:w-[144px] lg:top-1/4 lg:right-[80px] lg:w-[220px]"
                tag={["Cloud", "Paperless", "SpeedCMS"]}
              />
              {/* content */}
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>プロジェクトの期間を教えてください</Interviewer>
                <Interviewee>
                  全体としては数フェーズに渡るスケジュールでの開発でした。ファーストフェーズでは、ヒアリングから要件定義で約2ヶ月程度、それと並行してフロントエンド部分の開発が進んでいたので、システムの制作期間として2ヶ月。さらに検証に1ヶ月程度でしょうか。ただ、検証段階で追加要件が発生したため、その取り込みが発生して、検証の後にもシステムの部分開発が発生しました。
                </Interviewee>
                <Interviewer>
                  プロジェクトを通じて解決しようとしたクライアントの課題は何でしたか？
                </Interviewer>
                <Interviewee>
                  業務の効率化が一番。今までは、メールでのやりとりやエクセルでの表管理が中心でした。一部システム化されてはいたけれど、最初から最後まで1つのシステムで一貫して行えることが必要でした。
                </Interviewee>
                <Interviewer>課題をどのように分析しましたか？</Interviewer>
                <Interviewee>
                  クライアントにシステムに詳しい方がいらしたので、全てをヒアリングをしてというわけでは無く、お客様と一緒にどうしていくのがよいか考え、より良いカタチを提案していきました。
                </Interviewee>
                <div className="relative aspect-2/1">
                  <Image
                    src={projectIllust3}
                    alt="1つの要件で考えない。お客さまと共に見つけ出す、課題の解決法。"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  クライアントとの開発や連携に際し、使用したwebサービスは何を使用していましたか？
                </Interviewer>
                <Interviewee>
                  基本的には対面で定期MTGを行い、情報の共有はSlackを使用していました。開発環境・ソースコード管理はGithubを使用していました。
                </Interviewee>
                <Interviewer>どのようなチーム構成でしたか？</Interviewer>
                <Interviewee>
                  主にPM・PMO（PM補佐、プランニング）・プログラマー（外部）・テスターの4名で動いていました。
                </Interviewee>
                <Interviewer>
                  どのような開発ツールを使用しましたか？
                </Interviewer>
                <Interviewee>
                  今回のプロジェクトではphp・mysqlでプログラムを書きました。使用したアプリケーションはVSコード・eclipseを使用しました。また、弊社開発のSpeedCMSを用いました。
                </Interviewee>
                <Interviewer>
                  チームとして一緒に働きたくなるような人はどんな人ですか？
                </Interviewer>
                <Interviewee>
                  新しいモノに触れる事に対して、積極的で自主性がある方と働きたいですね。
                </Interviewee>
                <Interviewer>
                  チームで開発を進める上で気をつけていたことはなんですか？
                </Interviewer>
                <Interviewee>
                  お金をかければいくらでもできるけれど、コスト感も念頭に置いて、バランスをとった提案しています。1つの要件だけで考えないように、システム的観点で柔軟な対応ができるようにしていました。またプロジェクトを通して、メンバーが成長できることを期待しながら、仕事を振り分けていました。
                </Interviewee>
                <Interviewer>
                  クライアントとToccaSystemsとはどのように接点を持ちましたか？
                </Interviewer>
                <Interviewee>
                  今回のプロジェクトはプライム案件でした。（クライアントと直の場合は特に）責任が重くなる分、会社が成長できるなと思っています。プロジェクトを担当するにあたっては、「成長の土台とならなくてはいけない」という意識を持って取り組んでいました。（笑）
                </Interviewee>
                <Interviewer>
                  このプロジェクトを経て今後、挑んでみたいプロジェクトはありますか？
                </Interviewer>
                <Interviewee>
                  クライアントの要望の把握やシステムがどうあるべきか考えて提案をしていくのが楽しかったです。テストで想定したものではなく、ユーザーの本データが実際に入った時に感動が得られました。
                </Interviewee>
                <Interviewer>
                  ToccaSystemsで共に働いて欲しい人はどんなひとですか？
                </Interviewer>
                <Interviewee>
                  技術力よりも、お客様の課題に一緒に向き合い、お客様目線で、共に考えることができ、自分もユーザという立場を忘れずに、同じ志でプロジェクトを動かせる人がよいですね。
                </Interviewee>
              </div>
              <ProjectNav />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
